<template>
  <v-container fluid class="quote-system">
    <!-- Simple Header -->

    <!-- Clean Progress Stepper -->
    <v-card class="stepper-card mt-n10" flat>
      <div class="stepper-container">
        <div class="step-item" :class="{ active: step >= 1, completed: step > 1 }">
          <div class="step-number">
            <v-icon v-if="step > 1" size="18">mdi-check</v-icon>
            <span v-else>1</span>
          </div>
          <div class="step-content">
            <span class="step-title">Seleccionar Artículos</span>
            <small class="step-desc">Elige productos</small>
          </div>
        </div>

        <div class="step-divider" :class="{ active: step > 1 }"></div>

        <div class="step-item" :class="{ active: step >= 2, completed: step > 2 }">
          <div class="step-number">
            <v-icon v-if="step > 2" size="18">mdi-check</v-icon>
            <span v-else>2</span>
          </div>
          <div class="step-content">
            <span class="step-title">Definir Cantidades</span>
            <small class="step-desc">Especifica cantidades</small>
          </div>
        </div>

        <div class="step-divider" :class="{ active: step > 2 }"></div>

        <div class="step-item" :class="{ active: step >= 3 }">
          <div class="step-number">3</div>
          <div class="step-content">
            <span class="step-title">Seleccionar Proveedores</span>
            <small class="step-desc">Elige suplidores</small>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Filters Section -->
    <v-card class="filters-section" flat v-show="step == 1">
      <HeaderFilters @setFilters="getDataFilter" :disable_all="disableFilters" />
    </v-card>

    <!-- Step 1: Item Selection -->
    <v-expand-transition>
      <v-card v-show="step === 1" class="content-card" elevation="1">
        <div class="card-content">
          <!-- Skeleton Loading -->
          <div v-if="loading">
            <v-skeleton-loader type="chip, chip, chip" class="mb-4"></v-skeleton-loader>
            <v-skeleton-loader type="text, text" class="mb-4"></v-skeleton-loader>
            <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
          </div>

          <!-- Compact Stats -->
          <div v-else>
            <div class="stats-row">
              <div class="stat-chip">
                <v-icon size="16" color="info">mdi-package</v-icon>
                <span>{{ selectedsFilter.length }} Artículos</span>
              </div>
              <div class="stat-chip success">
                <v-icon size="16" color="success">mdi-check</v-icon>
                <span>{{ itemSelecteds.length }} Seleccionados</span>
              </div>
              <div class="stat-chip warning">
                <v-icon size="16" color="warning">mdi-clock</v-icon>
                <span>{{
                  selectedsFilter.filter((i) => i.status_quote.length === 0).length
                  }}
                  Pendientes</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn v-if="hasFeature('SHOP-052')" v-show="itemSelecteds.length > 0" @click="go_step_2()" color="success" class="action-btn"
                depressed>
                Cotizar ({{ itemSelecteds.length }})
                <v-icon right size="18">mdi-arrow-right</v-icon>
              </v-btn>
            </div>

            <!-- Search and Filters Row -->
            <div class="controls-row">
              <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Buscar artículos..." outlined dense
                clearable class="search-input" hide-details />

              <v-select v-model="statusType" :items="[
                { value: 1, text: 'Pendientes' },
                { value: 2, text: 'Cotizados' },
              ]" @change="getDataFilter(last_filters)" label="Estado" outlined dense class="status-select"
                hide-details />

              <v-btn icon @click="download_report()" color="success"><v-icon>mdi-download</v-icon></v-btn>
              <v-btn icon color="primary" @click="dialogSetting = true">
                <v-icon>mdi-cog-outline</v-icon>
              </v-btn>
              <v-btn icon @click="toggleSort()" :color="sortOrder === 'DESC' ? 'primary' : 'success'">
                <v-icon>{{ sortOrder === 'DESC' ? 'mdi-sort-clock-descending' : 'mdi-sort-clock-ascending' }}</v-icon>
              </v-btn>
            </div>
          <!-- El toggle de vista y la tabla van DENTRO del v-else (se ocultan mientras loading) -->

          <div class="view-mode-selector mb-4">
            <v-btn-toggle v-model="viewMode" mandatory color="primary" dense>
              <v-btn value="normal" small>
                <v-icon left size="16">mdi-format-list-bulleted</v-icon>
                Vista por Solicitudes
              </v-btn>
              <v-btn value="intelligent" small>
                <v-icon left size="16">mdi-brain</v-icon>
                Vista (Agrupada)
              </v-btn>
            </v-btn-toggle>
            <v-chip v-if="viewMode === 'intelligent'" x-small color="info" outlined class="ml-3">
              Agrupando ítems idénticos de múltiples departamentos
            </v-chip>
          </div>
          <!-- Data Table -->
          <v-data-table v-model="itemSelecteds" :headers="headersForItemsQuote" :items="currentTableItems"
            :search="search" item-key="item_key" show-select checkbox-color="success"
            class="clean-table groups-expanded" no-data-text="No se encontraron solicitudes"
            :group-by="viewMode === 'normal' ? 'request_id' : 'item_name'" :group-desc="sortOrder === 'DESC'"
            :opened.sync="openedGroups" :single-expand="false" :items-per-page="20">
            <!-- Custom Group Header -->
            <template v-slot:group.header="{ group, items, isOpen, toggle }">
              <td :colspan="headersForItemsQuote.length + 1" style="background: #f8fafc">
                <v-btn icon x-small @click="toggle" class="mr-2">
                  <v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                </v-btn>
                <template v-if="viewMode === 'normal'">
                  <v-chip color="primary" label small class="mr-2">SOLICITUD: {{ group }}</v-chip>
                  <span class="text-caption font-weight-bold grey--text text--darken-2">
                    {{ items.length }} artículo(s) de {{ items[0].requested_by }}
                  </span>
                </template>
                <template v-else>
                  <v-chip color="deep-purple" dark label small class="mr-2">ARTÍCULO: {{ group }}</v-chip>
                  <span class="text-caption font-weight-bold deep-purple--text">
                    Consolidando {{ items.length }} solicitudes individuales (Total: {{items.reduce((a, b) => a +
                      parseFloat(b.quantity), 0)}} {{ items[0].unit_name }})
                  </span>
                </template>
                <v-spacer></v-spacer>
              </td>
            </template>
            <!-- Custom Item Render for smarter look -->
            <template v-slot:[`item.item_name`]="{ item }">
              <div class="item-cell">
                <v-avatar size="32" class="mr-3" color="grey lighten-4">
                  <v-img v-if="item.item_image_url" :src="item.item_image_url"></v-img>
                  <v-icon v-else color="grey">mdi-package-variant-closed</v-icon>
                </v-avatar>
                <div class="item-info">
                  <span class="item-name-text">{{ item.item_name }}</span>
                  <small class="item-code">ID: {{ item.item_code }}</small>
                </div>
              </div>
            </template>

            <template v-slot:[`item.item_category_name`]="{ item }">
              <v-chip outlined small color="grey darken-1" class="font-weight-medium">
                {{ item.item_category_name }}
              </v-chip>
            </template>

            <template v-slot:[`item.global_stock`]="{ item }">
              <div class="stock-cell">
                <v-chip :color="item.quantity > (item.global_stock || 0) ? 'error' : 'success'" x-small label dark>
                  {{ item.global_stock || 0 }} {{ item.unit_name }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.last_price_paid`]="{ item }">
              <div class="ref-price-cell">
                <span v-if="item.last_price_paid" class="last-price-text">
                  {{ formatPrice(item.last_price_paid) }}
                </span>
                <span v-else class="no-price">--</span>
              </div>
            </template>

            <template v-slot:[`item.lead_time`]="{ item }">
              <v-chip :color="getLeadTimeColor(item.lead_time)" x-small label dark>
                <v-icon left size="10">mdi-clock-outline</v-icon>
                {{ item.lead_time }}d
              </v-chip>
            </template>

            <template v-slot:[`item.status_quote`]="{ item }">
              <v-chip :color="item.difference == 0 ? 'success' : 'orange'" small label dark>
                {{ item.difference == 0 ? "Cotizado" : "Pendiente" }}
              </v-chip>
            </template>

            <template v-slot:[`item.note`]="{ item }">
              <div v-if="item.comments" class="comment-cell">
                <v-tooltip bottom max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="comment-text-truncated">
                      {{ getCommentText(item.comments) }}
                    </span>
                  </template>
                  <span>{{ getCommentText(item.comments) }}</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div><!-- Cierre v-else -->
        </div><!-- Cierre card-content -->
      </v-card>
    </v-expand-transition>

    <!-- Step 2: Quantity Definition -->
    <v-expand-transition>
      <v-card v-show="step === 2" class="content-card" elevation="1">
        <div class="card-header">
          <div class="header-left">
            <v-btn @click="go_step_1()" text color="error" class="back-btn">
              <v-icon left size="18">mdi-arrow-left</v-icon>
              Volver
            </v-btn>
            <v-icon color="primary" class="mx-3">mdi-counter</v-icon>
            <h3 class="section-title">Definir Cantidades</h3>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="grey" size="18" class="ml-2">mdi-help-circle</v-icon>
              </template>
              <span>Si no indica la cantidad completa, el resto quedará pendiente</span>
            </v-tooltip>
          </div>
          <v-btn @click="validateNextStep()" color="success" class="action-btn" depressed>
            Siguiente
            <v-icon right size="18">mdi-arrow-right</v-icon>
          </v-btn>
        </div>

        <div class="card-content">
          <div class="quantity-controls">
            <div class="stat-chip">
              <v-icon size="16" color="primary">mdi-package-variant</v-icon>
              <span>{{ itemSelecteds.length }} Artículos</span>
            </div>

            <div class="controls-group">
              <v-text-field v-model="searchSelected" prepend-inner-icon="mdi-magnify" label="Buscar..." outlined dense
                clearable hide-details class="search-small" />

              <v-btn @click="selectMaxAll(false)" color="primary" outlined small>
                <v-icon left size="16">mdi-auto-fix</v-icon>
                Cotizar Todo
              </v-btn>

              <div class="summary-power-board">
                <div class="board-header">RESUMEN EJECUTIVO</div>
                <div class="board-body">
                  <div v-for="total in totalEstimatedByCurrency" :key="total.code" class="board-item">
                    <span class="currency-label">{{ total.code }}</span>
                    <span class="currency-value">{{ formatPrice(total.amount, total.code) }}</span>
                  </div>
                  <div class="board-footer">
                    <span>{{ itemSelecteds.length }} Artículos seleccionados</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-data-table :headers="headersForItemsQuote" :items="itemSelecteds" :search="searchSelected"
            item-key="item_key" class="clean-table" no-data-text="No hay artículos seleccionados" :items-per-page="20">
            <template v-slot:[`item.quantity_selected`]="{ item }">
              <div class="quantity-input-group">
                <v-text-field v-model="item.quantity_selected" type="number" outlined dense :min="0.01" step="any"
                  :max="item.quantity" @change="validateQuantity(item)" class="quantity-field" hide-details="auto" />
                <!-- <div class="item-cost-hint">
                  <div v-for="c in item.item_currencies" :key="c.currency_code" class="currency-hint">
                    <small>{{ c.currency_code }}: {{ formatPrice(c.cost_price * item.quantity_selected, c.currency_code)
                    }}</small>
                  </div>
                </div> -->
              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-expand-transition>

    <!-- Step 3: Supplier Selection -->
    <v-expand-transition>
      <v-card v-show="step === 3" class="content-card" elevation="1">
        <div class="card-header">
          <div class="header-left">
            <v-btn @click="step = 2" text color="error" class="back-btn">
              <v-icon left size="18">mdi-arrow-left</v-icon>
              Volver
            </v-btn>
            <v-icon color="primary" class="mx-3">mdi-account-group</v-icon>
            <h3 class="section-title">Seleccionar Proveedores</h3>
          </div>
          <v-btn @click="save" color="success" class="action-btn" depressed>
            <v-icon left size="18">mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </div>

        <div class="card-content">
          <div class="stats-row">
            <div class="stat-chip">
              <v-icon size="16" color="info">mdi-store</v-icon>
              <span>{{ suppliers.length }} Proveedores</span>
            </div>
            <div class="stat-chip success">
              <v-icon size="16" color="success">mdi-check</v-icon>
              <span>{{ supplierSelected.length }} Seleccionados</span>
            </div>

            <v-divider vertical class="mx-2"></v-divider>

            <div class="summary-power-board horizontal">
              <div class="board-body">
                <div v-for="total in totalEstimatedByCurrency" :key="total.code" class="board-item">
                  <span class="currency-label">{{ total.code }}</span>
                  <span class="currency-value">{{ formatPrice(total.amount, total.code) }}</span>
                </div>
              </div>
            </div>
          </div>

          <v-text-field v-model="searchSuppliers" prepend-inner-icon="mdi-magnify" label="Buscar proveedores..."
            outlined dense clearable class="search-input mb-4" hide-details :loading="loadingSuppliers"
            placeholder="Escribe para buscar..." />

          <v-data-table v-model="supplierSelected" :headers="headerSuppliers" :items="suppliers" item-key="entity_id"
            show-select checkbox-color="success" class="clean-table" :loading="loadingSuppliers"
            loading-text="Cargando proveedores..." no-data-text="No hay proveedores disponibles" :items-per-page="20">
            <template v-slot:[`item.name`]="{ item }">
              <div class="supplier-cell">
                <v-avatar size="32" class="mr-3" color="blue lighten-5">
                  <v-icon color="blue">mdi-store-outline</v-icon>
                </v-avatar>
                <div class="supplier-info">
                  <span class="supplier-name">{{ item.name }}</span>
                  <div class="supplier-tags">
                    <v-chip v-if="item.is_frequent" x-small color="info" label dark>Frecuente</v-chip>
                    <v-chip v-if="item.is_expert" x-small color="success" label dark>Especialista</v-chip>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:[`item.mail`]="{ item }">
              <div class="mail-cell">
                <v-icon small color="grey" class="mr-1">mdi-email-outline</v-icon>
                <span>{{ item.mail || 'No disponible' }}</span>
              </div>
            </template>
            <template v-slot:[`item.lead_time`]="{ item }">
              <v-chip :color="getLeadTimeColor(item.lead_time || 5)" x-small label dark>
                {{ (item.lead_time || 5) }} días
              </v-chip>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-expand-transition>

    <!-- Settings Dialog -->
    <TableSettings :showDialog="dialogSetting" :header_table="headersForItemsQuote" @exit="dialogSetting = false" />

    <!-- Currency per Supplier Dialog -->
    <v-dialog v-model="dialogCurrency" max-width="560" persistent>
      <v-card>
        <v-card-title class="py-4 px-6" style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); border-bottom: 1px solid #e2e8f0;">
          <v-icon left color="primary">mdi-currency-usd</v-icon>
          <span class="font-weight-bold">Moneda de la cotizacion</span>
        </v-card-title>
        <v-card-subtitle class="px-6 pt-3 pb-0 mt-2">
          Indica la moneda de cotización para cada proveedor seleccionado.
        </v-card-subtitle>
        <v-card-text class="px-6 pt-4">
          <div
            v-for="supplier in supplierSelected"
            :key="supplier.entity_id"
            class="currency-row mb-3"
          >
            <div class="currency-row-supplier">
              <v-avatar size="32" color="blue lighten-5" class="mr-3">
                <v-icon color="blue" small>mdi-store-outline</v-icon>
              </v-avatar>
              <span class="font-weight-bold" style="color: #1e293b;">{{ supplier.name }}</span>
            </div>
            <v-select
              v-model="supplierCurrencies[supplier.entity_id]"
              :items="availableCurrencies"
              item-text="text"
              item-value="value"
              label="Moneda"
              outlined
              dense
              hide-details
              class="currency-select"
            />
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCurrency = false">Cancelar</v-btn>
          <v-btn color="success" depressed @click="saveWithCurrencies">
            <v-icon left size="18">mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import HeaderFilters from "@/components/Shop/QuotesFilters.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import TableSettings from "@/components/TableSettings.vue";
import ExcelJS from "exceljs";
export default {
  data: () => ({
    loading: true,
    loadingSuppliers: false,
    search: "",
    searchSelected: "",
    step: 1,
    searchTimeout: null,
    headersForItemsQuote: [
      {
        text: "ID Solicitud",
        align: "start",
        value: "request_id",
        require: true,
        active: true,
      },
      { text: "Fecha", value: "formatted_request_date", align: "center", require: true, active: true },
      { text: "Item", value: "item_name", align: "start", require: true, active: true },
      { text: "Categoría", value: "item_category_name", align: "start", require: false, active: true },
      { text: "Unidad", value: "unit_name", align: "center", require: false, active: true },
      {
        text: "Cant.",
        value: "quantity",
        align: "center",
        require: true,
        active: true,
      },
      {
        text: "Stock",
        value: "global_stock",
        align: "center",
        require: false,
        active: true,
      },
      // {
      //   text: "Ult. Precio",
      //   value: "last_price_paid",
      //   align: "center",
      //   require: false,
      //   active: true,
      // },
      // {
      //   text: "Lead Time",
      //   value: "lead_time",
      //   align: "center",
      //   require: false,
      //   active: true,
      // },
      {
        text: "Solicitante",
        value: "requested_by",
        align: "center",
        require: false,
        active: true,
      },
      {
        text: "Comentario",
        value: "note",
        align: "start",
        require: false,
        active: true,
      },
      {
        text: "Estatus",
        value: "status_quote",
        align: "center",
        require: true,
        active: true,
      },
      {
        text: "Cant. restante",
        value: "difference",
        width: "15%",
        align: " d-none",
        require: true,
        active: false,
      },
      {
        text: "Cant. a cotizar",
        value: "quantity_selected",
        width: "15%",
        align: " d-none",
        require: true,
        active: false,
      },
      {
        text: "Depto",
        value: "department_id",
        align: " d-none",
        require: false,
        active: false,
      },
    ],
    headerSuppliers: [
      { text: "ID", value: "entity_id", align: "start" },
      { text: "Identificación", align: "start", value: "document_id" },
      { text: "Nombre", value: "name", align: "start" },
      { text: "Entrega Est.", value: "lead_time", align: "center" },
      { text: "Correo", value: "mail", align: "center" },
    ],
    last_filters: {},
    statusType: 1,
    filters: {
      department_id: 0,
      location: { catalogue_id: "", id: "" },
      business: "",
      warehouse: { id: "", name: "" },
      dateStart: null,
      dateEnd: null,
    },
    dialogConfirm: false,
    itemsQuoteData: [],
    itemSelecteds: [],
    suppliers: [],
    supplierSelected: [],
    searchSuppliers: "",
    dialogSetting: false,
    dialogCurrency: false,
    supplierCurrencies: {},
    viewMode: "normal",
    suppliersPagination: null,
    sortOrder: "DESC",
    openedGroups: [],
  }),

  components: {
    HeaderFilters,
    DialogConfirm,
    TableSettings,
  },


  computed: {
    disableFilters() {
      return false;
    },
    selectedsFilter() {
      return this.itemsQuoteData;
    },
    currentTableItems() {
      return this.itemsQuoteData;
    },
    totalEstimatedByCurrency() {
      const totals = {};
      this.itemSelecteds.forEach((item) => {
        const qty = parseFloat(item.quantity_selected || 0);
        if (qty <= 0) return;

        if (item.item_currencies && Array.isArray(item.item_currencies)) {
          item.item_currencies.forEach((c) => {
            if (!totals[c.currency_code]) {
              totals[c.currency_code] = {
                name: c.currency_name,
                code: c.currency_code,
                amount: 0,
              };
            }
            const price = parseFloat(c.cost_price || 0);
            totals[c.currency_code].amount += price * qty;
          });
        }
      });
      return Object.values(totals);
    },
    availableCurrencies() {
      const map = new Map();
      this.itemSelecteds.forEach((item) => {
        if (item.item_currencies) {
          item.item_currencies.forEach((c) => {
            if (c.currency_id != null && !map.has(c.currency_id)) {
              map.set(c.currency_id, {
                value: c.currency_id,
                text: `${c.currency_code}${c.currency_name ? ' - ' + c.currency_name : ''}`,
              });
            }
          });
        }
      });
      return Array.from(map.values());
    },
    totalEstimatedCost() {
      // Valor base en DOP (ID: 1) para compatibilidad si se necesita un solo valor
      return this.itemSelecteds.reduce((total, item) => {
        return total + (parseFloat(item.price || 0) * parseFloat(item.quantity_selected || 0));
      }, 0);
    },
  },

  watch: {
    searchSuppliers(newVal) {
      // Limpiar timeout anterior
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Si el campo está vacío, cargar los primeros 25
      if (!newVal || newVal.trim() === '') {
        this.loadInitialSuppliers();
        return;
      }

      // Esperar 500ms después de que el usuario deje de escribir
      this.searchTimeout = setTimeout(() => {
        this.searchSuppliersInBackend(newVal);
      }, 500);
    },
    step(val) {
      // Cargar proveedores cuando llega al paso 3
      if (val === 3 && this.suppliers.length === 0) {
        this.loadInitialSuppliers();
      }

      const quantityHeader = this.headersForItemsQuote.find(
        (h) => h.value === "quantity_selected"
      );
      const statusHeader = this.headersForItemsQuote.find(
        (h) => h.value === "status_quote"
      );

      if (val === 1) {
        quantityHeader.active = false;
        statusHeader.active = true;
      } else {
        quantityHeader.active = true;
        statusHeader.active = false;
      }
    },
  },

  methods: {
    getCommentText(comments) {
      try {
        if (!comments) return "";

        if (typeof comments === "object") {
          if (Array.isArray(comments) && comments.length > 0) {
            if (Object.keys(comments[0]).length === 0) {
              return "";
            }
            if (comments[0].nota) {
              return comments[0].nota;
            }
          }
          const stringified = JSON.stringify(comments);
          return stringified === "[{}]" || stringified === "{}" ? "" : stringified;
        }

        if (typeof comments === "string") {
          if (comments.trim() === "[{}]" || comments.trim() === "{}") {
            return "";
          }

          try {
            const parsedComments = JSON.parse(comments);
            if (Array.isArray(parsedComments) && parsedComments.length > 0) {
              if (Object.keys(parsedComments[0]).length === 0) {
                return "";
              }
              if (parsedComments[0].nota) {
                return parsedComments[0].nota;
              }
            }

            if (Object.keys(parsedComments).length === 0) {
              return "";
            }

            return comments;
          } catch (e) {
            return comments;
          }
        }

        return "";
      } catch (error) {
        console.error("Error parsing comment:", error);
        return "";
      }
    },



    async loadInitialSuppliers() {
      try {
        this.loadingSuppliers = true;

        // Cargar los primeros 25 proveedores
        const url = `accounting/entity_suppliers_paginated?page=1&limit=25`;
        let resultEntity = await this.api_Get(url);
        const response = await resultEntity.json();

        this.suppliers = response.data || [];
        this.suppliersPagination = response.pagination;
      } catch (error) {
        this.$toast.error("Error al cargar proveedores: " + error);
        this.suppliers = [];
      } finally {
        this.loadingSuppliers = false;
      }
    },

    async searchSuppliersInBackend(searchTerm) {
      try {
        this.loadingSuppliers = true;

        // Buscar en el backend con el término de búsqueda
        const url = `accounting/entity_suppliers_paginated?page=1&limit=50&search=${encodeURIComponent(searchTerm)}`;
        let resultEntity = await this.api_Get(url);
        const response = await resultEntity.json();

        this.suppliers = response.data || [];
        this.suppliersPagination = response.pagination;
      } catch (error) {
        this.$toast.error("Error al buscar proveedores: " + error);
        this.suppliers = [];
      } finally {
        this.loadingSuppliers = false;
      }
    },

    async getDataFilter(filters) {
      this.last_filters = filters;
      this.filters = filters;
      if (filters.location.id == undefined) {
        filters.location.id = filters.location.value;
      }
      let filtros = ` WHERE REQUEST_WITH_DETAILS.BUSINESS_UNIT_ID=${filters.business}`;
      filtros +=
        filters.location.id != 0 ? " AND REQUEST_WITH_DETAILS.LOCATION_ID=" + filters.location.id : "";
      filtros +=
        filters.warehouse.id != 0 ? " AND WAREHOUSE_ID=" + filters.warehouse.id : "";
      filtros += filters.project.id != 0 ? " AND PROJECT_ID=" + filters.project.id : "";
      filtros +=
        filters.applicant.id != 0 ? " AND REQUESTED_BY=" + filters.applicant.id : "";
      filtros +=
        filters.department_id != 0 ? " AND DEPARTMENT_ID=" + filters.department_id : "";

      filtros += this.statusType == 1 ? " AND difference>0" : " AND difference<=0";
      try {
        this.loading = true;
        const request = await this.api_Post("shopping/articles_for_quotes", {
          filters: filtros,
          sort_order: this.sortOrder,
        });
        const data = await request.json();
        if (request.status == 200) {
          this.itemsQuoteData = data;
          for (let key in this.itemsQuoteData) {
            this.itemsQuoteData[key].quantity = parseFloat(this.itemsQuoteData[key].quantity).toFixed(2);
            this.itemsQuoteData[key].difference = parseFloat(this.itemsQuoteData[key].difference).toFixed(2);
          }

          // Automatically expand all groups by adding all unique request_ids to openedGroups
          const uniqueRequestIds = [...new Set(this.itemsQuoteData.map(item => item.request_id))];
          this.openedGroups = uniqueRequestIds;
        } else {
          this.$toast.error("Error: " + (data.error || data.message || data.msg || data.detail || JSON.stringify(data)));
        }
      } catch (error) {
        this.$toast.error("Error: " + (error?.message || error));
      } finally {
        this.loading = false;
      }
    },

    toggleSort() {
      this.sortOrder = this.sortOrder === "DESC" ? "ASC" : "DESC";
      this.getDataFilter(this.last_filters);
    },

    validateQuantity(item) {
      if (parseFloat(item.quantity_selected) > parseFloat(item.quantity)) {
        this.$toast.warning(
          "La cantidad indicada es mayor a la solicitada. Se ha ajustado automáticamente."
        );
        let index = this.itemSelecteds.indexOf(item);
        this.itemSelecteds[index].quantity_selected = item.quantity;
      }
    },

    selectMaxAll(is_validate) {
      for (let key in this.itemSelecteds) {
        if (is_validate == false) {
          this.itemSelecteds[key].quantity_selected = this.itemSelecteds[key].difference;
          continue;
        }
        if (parseFloat(this.itemSelecteds[key].quantity_selected) == 0) {
          this.$toast.warning(
            `Debe indicar la cantidad a cotizar del artículo: ${this.itemSelecteds[key].item_name}.`
          );
          return false;
        }
      }
      return true;
    },

    validateNextStep() {
      if (this.selectMaxAll(true)) this.step = 3;
    },

    ViewGroup(item) {
      const routeData = this.$router.resolve({
        name: "ViewQuoteGroup",
        params: { id: item },
      });
      window.open(routeData.href, "_blank");
    },

    save() {
      if (this.supplierSelected.length == 0) {
        this.$toast.warning("Debe seleccionar al menos un proveedor");
        return;
      }

      // Reset to null — user must explicitly select a currency for each supplier
      const currencies = {};
      for (const supplier of this.supplierSelected) {
        currencies[supplier.entity_id] = null;
      }
      this.supplierCurrencies = currencies;
      this.dialogCurrency = true;
    },

    async saveWithCurrencies() {
      for (const supplier of this.supplierSelected) {
        if (this.supplierCurrencies[supplier.entity_id] == null) {
          this.$toast.warning(`Debe seleccionar la moneda para ${supplier.name}`);
          return;
        }
      }

      const suppliersArray = this.supplierSelected.map((s) => ({
        entity_id: s.entity_id,
        currency_id: this.supplierCurrencies[s.entity_id],
      }));

      const itemDetails = this.itemSelecteds.map((item) => ({
        item_id: item.item_id,
        request_id: item.request_id,
        department_id: item.department_id,
        quantity: parseFloat(item.quantity_selected),
        price: null,
      }));

      try {
        const request = await this.api_Post("shopping/save_quotes", {
          business_unit_id: this.filters.business,
          user_id: this.$store.state.auth.user.user.user_id,
          suppliers: suppliersArray,
          quotation_details: itemDetails,
        });

        const data = await request.json();
        if (request.status == 200) {
          this.dialogCurrency = false;
          this.$toast.success("Cotizaciones registradas correctamente");
          this.ViewGroup(data[0].quotation_id);
          this.clear();
          this.getDataFilter(this.filters);
          this.step = 1;
        } else {
          this.$toast.error("Error: " + (data.error || data.message || data.msg || data.detail || JSON.stringify(data)));
        }
      } catch (error) {
        this.$toast.error("Error: " + (error?.message || error));
      }
    },

    clear() {
      this.supplierSelected = [];
      this.itemSelecteds = [];
    },
    async download_report() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Orden de Compra");
      // Definir encabezados
      worksheet.columns = [
        { header: "Solicitud ID", key: "id", width: 10 },
        { header: "Fecha", key: "requested_at", width: 20 },
        { header: "Almacén", key: "warehouse_name", width: 20 },
        { header: "Item", key: "item_name", width: 20 },
        { header: "Unidad", key: "unit_name", width: 15 },
        { header: "Cantidad solicitada", key: "quantity", width: 20 },
        { header: "Cantidad cotizada", key: "remaining", width: 20 },
        { header: "Cantidad restante", key: "difference", width: 20 },
        { header: "Responsable", key: "requested_by", width: 15 },
        { header: "Estatus", key: "last_status_name", width: 15 },
        { header: "Nota", key: "comments", width: 50 },
      ];

      this.selectedsFilter.forEach((item) => {
        worksheet.addRow({
          id: item.request_id,
          requested_at: item.requested_at,
          warehouse_name: item.warehouse_name,
          item_name: item.item_name,
          unit_name: item.unit_name,
          quantity: item.quantity,
          remaining: item.quantity - item.difference,
          difference: item.difference,
          requested_by: item.requested_by,
          last_status_name: item.last_status_name,
          comments: this.getCommentText(item.comments),
        });
      });

      // Generar el archivo Excel
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Reporte de solicitudes.xlsx`;
      link.click();
    },
    go_step_1() {
      // Mostrar columnas principales
      const toShow = ["formatted_request_date", "unit_name", "requested_by", "note", "status_quote", "global_stock", "last_price_paid", "lead_time"];
      this.headersForItemsQuote.forEach(h => {
        if (toShow.includes(h.value)) {
          h.align = h.value === "note" ? "start" : "center";
          h.active = true; // Ensure they are active
        }
      });

      // Ocultar columnas de cotización
      const toHide = ["difference", "quantity_selected", "department_id"];
      this.headersForItemsQuote.forEach(h => {
        if (toHide.includes(h.value)) {
          h.align = " d-none";
          h.active = false; // Ensure they are inactive
        }
      });

      this.step = 1;
    },
    go_step_2() {
      // Ocultar columnas informativas
      const toHide = ["formatted_request_date", "unit_name", "requested_by", "note", "status_quote", "department_id", "global_stock", "last_price_paid", "lead_time"];
      this.headersForItemsQuote.forEach(h => {
        if (toHide.includes(h.value)) {
          h.align = " d-none";
          h.active = false; // Ensure they are inactive
        }
      });

      // Mostrar columnas de cotización
      const toShow = ["difference", "quantity_selected"];
      this.headersForItemsQuote.forEach(h => {
        if (toShow.includes(h.value)) {
          h.align = "center";
          h.active = true; // Ensure they are active
        }
      });

      this.step = 2;
    },
    formatPrice(value, currencyCode = "DOP") {
      if (!value && value !== 0) return currencyCode + " 0.00";
      return new Intl.NumberFormat("es-DO", {
        style: "currency",
        currency: currencyCode,
      }).format(value);
    },
    getLeadTimeColor(days) {
      if (!days) return "grey";
      if (days < 3) return "success";
      if (days <= 7) return "orange";
      return "error";
    }
  },
};
</script>

<style scoped>
.quote-system {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
  padding: 20px;
}

/* Simple Header */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(10px);
}

.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 6px 0 0 0;
}

/* Clean Stepper */
.stepper-card {
  margin-bottom: 10px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: white;
}

.stepper-container {
  display: flex;
  align-items: center;
  padding: 28px 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.step-item {
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.step-item.active {
  opacity: 1;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.step-item.active .step-number {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  transform: scale(1.05);
}

.step-item.completed .step-number {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  transform: scale(1.05);
}

.step-content {
  display: flex;
  flex-direction: column;
}

.step-title {
  font-weight: 700;
  color: #1e293b;
  font-size: 0.95rem;
  margin-bottom: 2px;
}

.step-desc {
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 500;
}

.step-divider {
  width: 80px;
  height: 3px;
  background: #e2e8f0;
  margin: 0 24px;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.step-divider.active {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

/* Filters Section */
.filters-section {
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Content Cards */
.content-card {
  border-radius: 12px;
  margin-bottom: 20px;
  border: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: white;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px 12px 0 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.card-content {
  padding: 32px;
}

/* Stats */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.stat-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #475569;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.stat-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-chip.success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #047857;
  border-color: #a7f3d0;
}

.stat-chip.warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  color: #d97706;
  border-color: #fde68a;
}

/* Controls */
.controls-row {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.search-input {
  flex: 1;
  max-width: 350px;
}

.status-select {
  min-width: 150px;
}

.quantity-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.controls-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.search-small {
  max-width: 200px;
}

/* Buttons */
.action-btn {
  text-transform: none;
  font-weight: 700;
  padding: 12px 24px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  letter-spacing: 0.25px;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.back-btn {
  text-transform: none;
  color: #64748b;
  margin-right: 12px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background-color: #f1f5f9;
  color: #475569;
}

/* Table */
.clean-table {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.clean-table>>>.v-data-table__wrapper {
  border-radius: 12px;
}

.clean-table>>>.v-data-table-header {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.clean-table>>>.v-data-table-header th {
  font-weight: 700;
  color: #1e293b;
  border-bottom: 2px solid #e2e8f0;
  padding: 16px 12px;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clean-table>>>tbody tr {
  transition: all 0.2s ease;
}

.clean-table>>>tbody tr:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.005);
}

.clean-table>>>tbody td {
  padding: 16px 12px;
  border-bottom: 1px solid #f1f5f9;
}

/* Enhanced Chips */
.clean-table>>>.v-chip {
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  padding: 0 12px;
  height: 28px;
}

.clean-table>>>.v-chip.success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.clean-table>>>.v-chip.orange {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

/* Quantity Field */
.quantity-field {
  max-width: 100px;
}

/* Item Cell */
.item-cell {
  display: flex;
  align-items: center;
}

.item-info {
  display: flex;
  flex-direction: column;
}

.item-name-text {
  font-weight: 700;
  color: #1e293b;
  font-size: 0.9rem;
  line-height: 1.2;
}

.item-code {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Budget Cell */
.budget-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.budget-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 700;
  white-space: nowrap;
}

/* Comment Cell */
.comment-cell {
  max-width: 200px;
}

.comment-text-truncated {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.85rem;
  color: #475569;
  cursor: pointer;
}

.comment-text-truncated:hover {
  color: #3b82f6;
}

/* Summary Power Board */
.summary-power-board {
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  min-width: 250px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.summary-power-board.horizontal {
  min-width: auto;
  flex: 1;
}

.summary-power-board .board-header {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 16px;
  font-size: 0.65rem;
  letter-spacing: 1px;
  color: #94a3b8;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.summary-power-board .board-body {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-power-board.horizontal .board-body {
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}

.summary-power-board .board-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.summary-power-board.horizontal .board-item {
  gap: 10px;
}

.summary-power-board .currency-label {
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 600;
}

.summary-power-board .currency-value {
  color: #f8fafc;
  font-size: 1.1rem;
  font-weight: 800;
  font-family: 'Inter', sans-serif;
}

.summary-power-board .board-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.7rem;
  color: #64748b;
  text-align: right;
}

/* Expert Cells */
.stock-cell .v-chip {
  min-width: 80px;
  justify-content: center;
}

.last-price-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
}

.no-price {
  color: #cbd5e1;
}

/* Step 2 Extras */
.total-estimated-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.total-estimated-card {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  box-shadow: 0 4px 12px rgba(30, 41, 59, 0.2);
  min-width: 180px;
}

.total-estimated-card.mini {
  padding: 8px 16px;
  min-width: 140px;
}

.total-estimated-card .label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.8;
  font-weight: 700;
  margin-bottom: 2px;
}

.total-estimated-card .value {
  font-size: 1.25rem;
  font-weight: 800;
}

.item-cost-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 4px;
}

.currency-hint {
  line-height: 1;
}

.item-cost-hint small {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 600;
  white-space: nowrap;
}

/* Step 3 Summary Brief */
.quote-summary-brief {
  display: flex;
  gap: 24px;
  align-items: center;
}

.summary-item {
  display: flex;
  flex-direction: column;
}

.summary-item .label {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
}

.summary-item .value {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
}

/* Supplier Cell */
.supplier-cell {
  display: flex;
  align-items: center;
}

.supplier-info {
  display: flex;
  flex-direction: column;
}

.supplier-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 0.9rem;
}

.supplier-tags {
  display: flex;
  gap: 4px;
  margin-top: 2px;
}

.mail-cell {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #64748b;
}

/* Currency Dialog */
.currency-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.currency-row-supplier {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.currency-select {
  max-width: 210px;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .quote-system {
    padding: 8px;
  }

  .stepper-container {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .step-divider {
    width: 2px;
    height: 20px;
    margin: 0;
  }

  .card-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .controls-row {
    flex-direction: column;
    align-items: stretch;
  }

  .quantity-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .stats-row {
    flex-direction: column;
  }
}

/* Dark theme support */
.theme--dark .page-header {
  background: #1f2937;
}

.theme--dark .page-title {
  color: #f9fafb;
}

.theme--dark .page-subtitle {
  color: #d1d5db;
}

.theme--dark .content-card {
  background: #1f2937;
  border-color: #374151;
}

.theme--dark .card-header {
  background: #111827;
  border-color: #374151;
}

.theme--dark .section-title {
  color: #f9fafb;
}

.theme--dark .clean-table>>>.v-data-table-header {
  background: #111827;
}

.theme--dark .clean-table>>>.v-data-table-header th {
  color: #f9fafb;
  border-color: #374151;
}
</style>
